import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=1bf4725c&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bf4725c')) {
      api.createRecord('1bf4725c', component.options)
    } else {
      api.reload('1bf4725c', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=1bf4725c&", function () {
      api.rerender('1bf4725c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22Uxsa3IFjmIX/JS/comp/childrenage.vue"
export default component.exports